/* eslint-disable arrow-body-style */
import { Typography , Container, Stack  } from "@mui/material";

const Merchant = () => {
  return (
    <>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
           PSLCORP INFO
          </Typography>
        </Stack>
      </Container>
    </>
  );
};

export default Merchant;
